import { BenefitCardTemplate, BenefitCardTemplateProps } from "./template";

export type BenefitCardProps = BenefitCardTemplateProps;

export const BenefitCard = (props: BenefitCardProps): JSX.Element => {
  return <BenefitCardTemplate {...props} />;
}; 